import React from 'react';
import PropTypes from 'prop-types';

import { formatMoneyAmount } from '@common/helpers/amount';
import { roundAmount } from '@betslip/src/rules/calculation/helpers';

// This code will be removed after

const MoneyAmount = ({ config, amount, currencyConfig }) => {
  if (amount === undefined) return '-';

  const calculateAmountRate = (config, amount, currencyConfig) => {
    if (currencyConfig && currencyConfig.name === 'BGN') {
      return roundAmount(((amount * 1000000) / (config.main.additionalCoinRate * 1000000)), currencyConfig);
    }

    if (currencyConfig && currencyConfig.name === 'EUR') {
      return roundAmount(((amount * config.main.additionalCoinRate)), currencyConfig);
    }
  };

  return (
    <>
      {' '}
      {formatMoneyAmount(amount, config, currencyConfig)}
      {' '}
      {config.main.showAdditionalCoin && <span className="info-additional-currency">{`/ ${calculateAmountRate(config, amount, currencyConfig)} ${config.main.additionalCoinMap[currencyConfig.name]}`}</span>}
    </>
  );
};

MoneyAmount.propTypes = {
  config: PropTypes.object,
  amount: PropTypes.number,
  currencyConfig: PropTypes.object,
};

export default MoneyAmount;
